<template>
    <button :id="id" type="button" :class="classes" @click="doAction">
        {{actionLabel}}
    </button>
</template>

<script>

export default {
  props: {
    id: String,
    classes: {
      type: String,
      default: 'ui fluid basic button'
    },
    action: Function
  },
  data: function () {
    return {
      btnDisabled: false,
      currentInterval: null,
      currentTimer: null
    }
  },
  methods: {
    doAction: function () {
      if (this.btnDisabled === false) {
        this.action()
      }
    },
    disableActionForTime: function (time) {
      console.debug('Disabling button for ' + time + ' second(s)...')
      this.btnDisabled = true
      this.setActionText(this.$t('common.button.sent'))
      this.startCountdown(time, this.enableAction, this.setCooldownText)
    },
    startCountdown: function (duration, enableActionFunc, setTextFunc) {
      $('#' + this.id).attr('aria-label', this.$t('aria.common.resendDisabled', {
        0: duration
      }))

      this.currentTimer = duration; let minutes; let seconds
      const _this = this
      this.currentInterval = setInterval(function () {
        minutes = parseInt(_this.currentTimer / 60, 10)
        seconds = parseInt(_this.currentTimer % 60, 10)

        minutes = minutes < 10 ? '0' + minutes : minutes
        seconds = seconds < 10 ? '0' + seconds : seconds

        if ((duration - _this.currentTimer) > 0) {
          setTextFunc(minutes + ':' + seconds)
        }

        if (--_this.currentTimer < 0) {
          enableActionFunc()
          clearInterval(_this.currentInterval)
          console.log('Clearing timer...')
        }
      }, 1000)
    },
    setCooldownText: function (cooldown) {
      this.setActionText(this.$t('common.button.resendCodeIn', { 0: cooldown }))
    },
    setActionText: function (text) {
      $('#' + this.id).text(text)
    },
    enableAction: function () {
      this.btnDisabled = false
      $('#' + this.id).removeAttr('aria-label')
      this.setActionText(this.actionLabel)
    }
  },
  computed: {
    actionLabel: function () {
      return this.$t('common.button.resend')
    }
  },
  mounted: function () {
    const remainingTimer = this.$store.state.remainingCooldown
    if (remainingTimer && remainingTimer > 0) {
      console.debug('Remaining cooldown of ' + remainingTimer + ' seconds')
      this.disableActionForTime(remainingTimer)
    }
  },
  beforeDestroy: function () {
    console.debug('Persisting remaining time and clearing current button cooldown')
    clearInterval(this.currentInterval)
    this.$store.commit('remainingCooldown', this.currentTimer)
  }
}
</script>

<style scoped>
</style>
